import { ArrowLeft } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export function ChatHeader() {
	const t = useTranslations("aiBuilder");
	return (
		<div className="bg-card/50 backdrop-blur">
			<div className="flex items-center justify-between gap-4 p-4">
				<div className="flex items-center gap-3">
					<Button
						aria-label={t("header.back")}
						asChild
						size="icon"
						variant="outline"
					>
						<Link href="/form-builder">
							<ArrowLeft aria-hidden className="size-4" />
						</Link>
					</Button>
					<h1 className="font-semibold text-lg">AI</h1>
				</div>
			</div>
			<Separator />
		</div>
	);
}
